export default __webpack_public_path__ + "static/media/closet5-before2.c6a0288e.jpg";